var map = {
	"./avatar-abbey-base-full.png": 18552,
	"./avatar-abbey-dino-full.png": 57453,
	"./avatar-abbey-fall-full.png": 4860,
	"./avatar-abbey-smoothie-full.png": 24937,
	"./avatar-abbey-space-full.png": 83207,
	"./avatar-abbey-spring-full.png": 45392,
	"./avatar-abbey-summer-full.png": 42664,
	"./avatar-abbey-winter-full.png": 1772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15013;